<template>
<div class="flex flex-wrap flex-grow items-baseline">
    <select-dropdown
        v-for="(study, index) in validOptions"
        :value="selectedStudies ? selectedStudies[index] : null"
        :options="options[index]"
        :autoTranslate="false"
        :key="'study-selector-dropdown-' + $vnode.key + '-' + index"
        @change="selectAndGenerateChildren($event, index)"
        class="w-full mb-8">
    </select-dropdown>
</div>
</template>

<script>
import * as vdab from '../../services/VdabService';
import SelectDropdown from '../forms/SelectDropdown.vue';

export default {
    components: {
        'select-dropdown': SelectDropdown,
    },
    props: {
        topLvlStudies: {
            default: [],
            validator: value => Array.isArray(value),
        },
        value: {
            default: {},
        },
    },
    data: function () {
        return {
            selectedStudies: this.value.path ? this.value.path.split('.') : [],
            topOptions: [],
            options: [[]],
            dummyTopOption: {
                label: '-- ' + this.$t('vdab.choose_study') + ' --',
                value: null,
                id: null,
                has_children : null,
            },
            dummyOption: {
                label: '-- ' + this.$t('general.refine') + ' --',
                value: null,
                id: null,
                has_children : null,
            },
        }
    },
    computed: {
        selectedStudy: {
            get () {
                return this.value;
            },
            set (value) {
                this.$emit('input', value);
            },
        },
        validOptions () {
            return this.options.filter(Boolean);
        }
    },
    methods: {
        async selectAndGenerateChildren (id, index) {
            this.options.splice(index + 1);

            //if placeholder value chosen
            if (!id) {
                this.selectedStudies.splice(index);
                this.selectedStudy = null;
                return;
            }

            let study = this.options[index].find(study => study.id === id);

            let studies = [...this.selectedStudies];

            studies.splice(index);

            studies.push(id);
            this.selectedStudies = [...studies];

            this.setSelectedStudy();

            //return early if selected study has no children
            if (!study.has_children) {
                return;
            }

            //get children of selected study
            let children = await this.getChildrenOptions(study.id);

            if (children.length > 0) {
                this.selectedStudies.push(null);
                this.options.push(children);
            }
        },
        async initOptions (studies) {
            //each index represents a new lvl in heriarchy
            let options = studies.map(study => ({
                ...study,
                label: study.name,
                value: study.id
            }));
            options.unshift(this.dummyTopOption);

            this.topOptions = options;
            options = [options];

            for (let index in this.selectedStudies) {
                let study = options[index].find(study => study.id === this.selectedStudies[index]);

                //return early if study has no children
                if (!study.has_children) {
                    break;
                }

                let subOptions = await this.getChildrenOptions(this.selectedStudies[index]);

                if (subOptions.length > 0) {
                    options.push(subOptions);
                }
            }

            this.options = options;
        },
        async getChildrenOptions (id) {
            return await vdab.indexStudies(null, id).then(result => {
                if (result.length <= 0) {
                    return [];
                }

                let options = result.map(child => ({
                    ...child,
                    label: child.name,
                    value: child.id
                }));

                options.unshift(this.dummyOption);
                return options;
            });
        },
        setSelectedStudy () {

            let id = this.selectedStudies[this.selectedStudies.length - 1];

            for (let index in this.options) {
                let option = this.options[index].find(study => study.id === id);

                if (option) {
                    option = {...option};
                    delete option.label;
                    delete option.value;
                    this.selectedStudy = option;
                }
            }
        }
    },
    mounted () {
        if (this.topLvlStudies.length > 0) {
            this.initOptions(this.topLvlStudies);
        }
    },
    watch: {
        topLvlStudies(newStudies) {
            this.initOptions(newStudies);
        },
    },
}
</script>
